import * as React from "react";

function SvgHorizontalCenter(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}><path d="M9 3h2v14H9zM1.6 10.6V9.4h3.9L4.2 8.1 5 7l3 3-3 3-.8-1.1 1.3-1.3H1.6zM18.4 9.4v1.2h-3.9l1.3 1.3L15 13l-3-3 3-3 .8 1.1-1.3 1.3h3.9z" /></svg>;
}

export default SvgHorizontalCenter;